// src/pages/VietnameseNailCoursePage.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, PhoneCall, MessageCircle } from 'lucide-react';


const VietnameseNailCoursePage = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [coursesOpen, setCoursesOpen] = useState(false);

  return (
    <div className="bg-[#f7f6f3] text-gray-800 font-sans">
      {/* Header Bar */}
      <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
        <div className="flex flex-col md:flex-row items-center gap-2">
          <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">
            📧 admin@kentacademy.co.uk
          </a>
        </div>
        <a
          href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:underline flex items-center gap-1"
        >
          <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
          facebook.com/KentAcademy
        </a>
      </div>

      {/* Brand Header */}
      <nav className="bg-white shadow-sm w-full z-40 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
          <Link to="/" className="cursor-pointer">
            <img
              src="/assets/KaLogo.png"
              alt="Kent Academy"
              className="h-40 w-auto object-contain"
            />
          </Link>
        </div>


        {/* Desktop Nav */}
        <div className="bg-[#f7f6f3] border-t border-gray-200 hidden md:flex">
          <div className="max-w-4xl mx-auto px-4 flex justify-between items-center text-sm font-medium py-3 relative w-full">
            <Link to="/" className="text-gray-800 hover:text-black transition">HOME</Link>
            <Link to="/about" className="text-gray-800 hover:text-black transition">ABOUT US</Link>

            {/* ALL COURSES */}
            <div
              className="relative cursor-pointer group"
              onMouseEnter={() => setCoursesOpen(true)}
              onMouseLeave={() => setCoursesOpen(false)}
            >
              <div className="flex items-center gap-1 text-gray-800 hover:text-black transition">
                <span>ALL COURSES</span>
                <ChevronDown size={16} className={`${coursesOpen ? 'rotate-180' : ''} transition-transform duration-200`} />
              </div>

              <div
                className={`absolute top-full left-1/2 -translate-x-1/2 mt-1 transition-all duration-200 z-50 ${
                  coursesOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'
                }`}
              >
                <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45" />
                <div className="bg-white border border-gray-200 rounded-md shadow-lg w-72 overflow-hidden">
                  <div className="py-1">
                    {/* ✅ Vietnamese course moved to top */}
                    <a href="/courses/vietnamese-nails" className="block px-4 py-2 hover:bg-gray-50 transition-colors">
  <div className="flex items-center gap-2">
    <div className="w-2 h-2 bg-pink-600 rounded-full" />
    <div>
      <h4 className="font-medium text-gray-900 text-sm">Level 3 in Nail Technology</h4>
      <p className="text-xs text-gray-600">Bilingual (EN & VN)</p>
    </div>
  </div>
</a>


                    <Link to="/courses/laser-and-light" className="block px-4 py-2 hover:bg-gray-50 transition-colors">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-blue-600 rounded-full" />
                        <div>
                          <h4 className="font-medium text-gray-900 text-sm">Level 4 in Laser and Light</h4>
                          <p className="text-xs text-gray-600">Professional laser training</p>
                        </div>
                      </div>
                    </Link>

                    <Link to="/courses/tattoo-removal" className="block px-4 py-2 hover:bg-gray-50 transition-colors">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-purple-600 rounded-full" />
                        <div>
                          <h4 className="font-medium text-gray-900 text-sm">Level 5 in Tattoo Removal</h4>
                          <p className="text-xs text-gray-600">CPD Available</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <Link to="/contact" className="text-gray-800 hover:text-black transition">CONTACT</Link>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden flex justify-center pb-3">
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="text-sm border px-4 py-2 rounded text-gray-800 border-gray-600 hover:bg-gray-100 transition"
          >
            {mobileOpen ? 'Close Menu' : 'Menu'}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-[#f7f6f3] border-t border-gray-200 px-6 py-4 flex flex-col items-center gap-3 text-sm font-medium">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition">HOME</Link>
            <Link to="/about" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition">ABOUT US</Link>

           {/* Dropdown for Courses */}
           <details className="w-full">
  <summary
    className="w-full flex justify-center items-center cursor-pointer text-gray-800 hover:text-black transition list-none py-2"
  >
    ALL COURSES
  </summary>
  <div className="flex flex-col mt-2 gap-2 text-center">
    <Link 
      to="/courses/vietnamese-nails" 
      onClick={() => setMobileOpen(false)} 
      className="text-gray-700 hover:text-black transition"
    >
      Level 3 Nail Training
    </Link>
    <Link 
      to="/courses/laser-and-light" 
      onClick={() => setMobileOpen(false)} 
      className="text-gray-700 hover:text-black transition"
    >
      Level 4 Laser & Light
    </Link>
    <Link 
      to="/courses/tattoo-removal" 
      onClick={() => setMobileOpen(false)} 
      className="text-gray-700 hover:text-black transition"
    >
      Level 5 Tattoo Removal
    </Link>
  </div>
</details>


<Link
  to="/contact"
  onClick={() => setMobileOpen(false)}
  className="text-gray-800 hover:text-black transition mt-2"
>
  CONTACT
</Link>

<Link
  to="/courses/level-3/welcome"
  className="mt-3 inline-flex items-center justify-center gap-2 px-8 py-4 bg-black text-white text-base font-bold rounded-md shadow hover:opacity-90 transition uppercase tracking-wide"
  onClick={() => setMobileOpen(false)}
>
  Register
</Link>
 
          </div>
        )}
      </nav>
{/* Who Is This For */}
<section className="py-16 bg-[#f7f6f3]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 md:order-1">
              <img
                src="/assets/Nails6.JPG"
                alt="Level 3 Nail Technology – who is this for"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl md:text-4xl font-light mb-6">
                Who Is This <span className="font-semibold">For?</span>
              </h3>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <p className="text-gray-700">
                    Vietnamese-speaking nail technicians<br />
                    <span className="text-gray-600 text-sm">Kỹ thuật viên làm móng nói tiếng Việt</span>
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <p className="text-gray-700">
                    Anyone already working in a UK nail bar who needs recognised certification<br />
                    <span className="// continuing the file with restored content
                text-gray-600 text-sm">Người đang làm việc tại tiệm nail ở Anh cần chứng chỉ được công nhận</span>
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <p className="text-gray-700">
                    Those needing recognised UK council certification<br />
                    <span className="text-gray-600 text-sm">Những người cần chứng chỉ được công nhận bởi Hội đồng tại Vương quốc Anh</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
     
     
      {/* ✅ New Course Structure Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h3 className="text-2xl font-semibold mb-6">Course Structure</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <ul className="space-y-2 text-gray-700">
              <li>Manicure</li>
              <li>Pedicure</li>
              <li>Electric Drills</li>
              <li>Acrylic - Clear, Coloured and Pink & White Powder, Embedding glitter in clear acrylic, Ombre</li>
              <li>Nailart to include 3D, marbelling, flowers, glitter and jewel application</li>
              <li>UV gel polish French and Dark</li>
              <li>Be able to show a display of products or promotions</li>
            </ul>
            <ul className="space-y-2 text-gray-700">
              <li>Móng</li>
              <li>Chân</li>
              <li>Máy khoan điện</li>
              <li>Acrylic - Bột trong suốt, có màu và hồng và trắng, Nhúng lấp lánh trong acrylic trong suốt, Ombre</li>
              <li>Nailart bao gồm ứng dụng 3D, marbelling, hoa, lấp lánh và đồ trang sức</li>
              <li>Sơn gel UV Pháp và Tối</li>
              <li>Có thể hiển thị màn hình sản phẩm hoặc chương trình khuyến mãi</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Black Box Enrol Section */}
      <section className="py-12 bg-white text-center">
  <div className="max-w-3xl mx-auto bg-black text-white rounded-lg p-6">
    <h4 className="text-xl font-semibold mb-2">
      Can you do this and want to enrol?
    </h4>
    <p className="mb-4">
      Bạn có muốn đăng ký và làm theo những yêu cầu như này?
    </p>
    <Link
      to="/courses/level-3/welcome"
      className="inline-block w-full sm:w-auto px-10 py-5 bg-white text-black text-lg font-bold uppercase rounded-lg shadow-lg hover:opacity-90 transition tracking-wide"
    >
      CLICK HERE / XIN HÃY BẤM VÀO ĐÂY
    </Link>
  </div>
</section>



      {/* Main Course Info */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>

              <h3 className="text-xl font-semibold mb-4">What We Offer</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-gray-900">Certification & Assessment</p>
                    <p className="text-gray-700 text-sm">Confirm your skills and receive official Level 3 certification recognised in the UK.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-gray-900">Bilingual Support</p>
                    <p className="text-gray-700 text-sm">Guidance and materials available in English & Vietnamese.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-gray-900">Compliance</p>
                    <p className="text-gray-700 text-sm">Certification meets UK council requirements.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-pink-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-gray-900">Process Guidance</p>
                    <p className="text-gray-700 text-sm">We help you register, submit evidence, and complete your assessment.</p>
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <p className="text-gray-700 font-semibold">📞 07548321022</p>
                <p className="text-gray-700 text-sm italic">Call or message us in Vietnamese or English</p>
                <div className="flex gap-3">
                  <a
                    href="tel:+447548321022"
                    className="px-6 py-3 bg-white text-gray-900 text-sm font-medium rounded-md shadow hover:bg-gray-100 transition inline-flex items-center gap-2"
                  >
                    <PhoneCall size={16} /> Call Now
                  </a>
                  <a
  href="https://wa.me/447735906672"
  target="_blank"
  rel="noopener noreferrer"
  className="px-6 py-3 bg-white text-gray-900 text-sm font-medium rounded-md shadow hover:bg-gray-100 transition inline-flex items-center gap-2"
>
  <MessageCircle size={16} /> WhatsApp
</a>

                </div>
              </div>
            </div>

            <div className="relative">
              <img
                src="/assets/Nails5.JPG"
                alt="Level 3 in Nail Technology certification"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="relative pt-44 pb-12 px-6 w-full">
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-light mb-4">
            Level 3 in <span className="font-semibold">Nail Technology</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto mb-6">
            Assessment and certification pathway for Vietnamese-speaking nail professionals in the UK.<br />
            <span className="text-gray-600 text-base">
              Khóa học này được thiết kế dành riêng cho các học viên làm trong ngành nails và cần có bằng của Vương quốc Anh.
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/courses/level-3/welcome"
              className="px-6 py-3 bg-black text-white text-sm font-medium rounded-md shadow hover:opacity-90 transition"
            >
            Can you do this and want to enrol?<br />
              <span className="text-gray-300">Bạn có muốn đăng ký và làm theo những yêu cầu như này?</span>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="py-16 bg-gray-800 text-white text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h3 className="text-3xl md:text-4xl font-light mb-6">
            Start Your <span className="font-semibold">Certification Journey</span>
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Confirm your skills and complete the process to become officially certified in the UK.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:+447548321022"
              className="px-6 py-3 bg-white text-gray-900 text-sm font-medium rounded-md shadow hover:bg-gray-100 transition inline-flex items-center gap-2"
            >
              <PhoneCall size={20} /> Call Us Now
            </a>
            <a
              href="https://wa.me/447735906672"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-white text-gray-900 text-sm font-medium rounded-md shadow hover:bg-gray-100 transition inline-flex items-center gap-2"
            >
              <MessageCircle size={20} /> WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <img src="/assets/KaLogo.png" alt="Kent Academy" className="w-14 mb-3" />
            <p className="text-gray-300">
              Kent Academy provides assessment and certification services with professional guidance.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Courses</h4>
            <ul className="space-y-1 text-gray-400">
              <li>Level 4 in Laser and Light</li>
              <li>Level 5 in Tattoo Removal</li>
              <li>Level 3 in Nail Technology</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Contact</h4>
            <ul className="space-y-1 text-gray-400">
              <li>
                <a href="mailto:admin@kentacademy.co.uk" className="hover:text-gray-300 transition">
                  admin@kentacademy.co.uk
                </a>
              </li>
              <li>General: 07548 321022</li>
              <li>Vietnamese Courses: 07548321022</li>
              <li>Unit 10, Creative Quarter, Javelin Way, Ashford TN24 8FN</li>
              <li>
                <a
                  href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white hover:underline"
                >
                  <img src="/assets/facebook-icon.png" alt="Facebook" className="w-6 h-6" />
                  facebook.com/KentAcademy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 text-center text-xs text-gray-400">
          © 2025 Kent Academy. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default VietnameseNailCoursePage;

